// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + chunkId + ".twh." + {"FavouritesUiDynamicBuyerInfoModal":"f35e5b4b","SmartBannerFullScreen":"3dfad555"}[chunkId] + ".css");